import React from 'react';
import SpeechToText from './components/SpeechToText';

const App = () => (
  <div className="App">
    <SpeechToText />
  </div>
);

export default App;
